export const blocCConstants = {
  GET_BLOCC_REQUEST: 'GET_BLOCC_REQUEST',
  GET_BLOCC_SUCCESS: 'GET_BLOCC_SUCCESS',
  GET_BLOCC_FAILURE: 'GET_BLOCC_FAILURE',

  UPDATE_BLOCC_REQUEST: 'UPDATE_BLOCC_REQUEST',
  UPDATE_BLOCC_SUCCESS: 'UPDATE_BLOCC_SUCCESS',
  UPDATE_BLOCC_FAILURE: 'UPDATE_BLOCC_FAILURE',
};
